import React from 'react';
import LocationTemplate from './LocationTemplate';

const LucamaPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Lucama"
      stateName="North Carolina"
      countyName="Wilson"
      zipCodes={["27851"]}
      latitude={35.6271}
      longitude={-78.0094}
      population={1102}
      historicalFact="Incorporated in 1915, developed as a rural agricultural community."
      nearbyTowns={[
        "Wilson, NC",
        "Kenly, NC",
        "Micro, NC",
        "Elm City, NC",
        "Black Creek, NC",
        "Stantonsburg, NC",
        "Middlesex, NC",
        "Bailey, NC"
      ]}
    />
  );
};

export default LucamaPage;